import * as Models from '@models';

export const modelsMap = new Map<string, any>([['users', Models.User]]);
